// =====================================
//
//   beginners guide Controller
//   Author: Gray
//   createtime: 2016 / 10 / 24
//
// =====================================

window.InifECMobileApp.controller("BeginnersGuideController", ['$scope', '$state', '$timeout', '$rootScope', '$PreviousState',
    function($scope, $state, $timeout, $rootScope, $PreviousState) {

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            var backState = $PreviousState.getBeginnersGuidePrevious();

            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {

        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================
        $scope.goBack = goBack;
        $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;

        //==========================
        //  Init
        //==========================
        init();
    }
]);